var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsergroupBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 6.0026C11.1052 6.0026 12.0007 5.10717 12.0007 4.0026C12.0007 2.89803 11.1052 2.0026 10.0007 2.0026M12.0007 9.33594C13.1701 9.5924 14.0007 10.2419 14.0007 11.0026C14.0007 11.6888 13.3248 12.2845 12.334 12.5829M8.66732 4.0026C8.66732 5.47536 7.47341 6.66927 6.00065 6.66927C4.52789 6.66927 3.33398 5.47536 3.33398 4.0026C3.33398 2.52984 4.52789 1.33594 6.00065 1.33594C7.47341 1.33594 8.66732 2.52984 8.66732 4.0026ZM10.6673 11.3359C10.6673 12.8087 8.57798 14.0026 6.00065 14.0026C3.42332 14.0026 1.33398 12.8087 1.33398 11.3359C1.33398 9.86318 3.42332 8.66927 6.00065 8.66927C8.57798 8.66927 10.6673 9.86318 10.6673 11.3359Z",
    stroke: "#8B7EFB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsergroupBlueIcon);
export default __webpack_public_path__ + "static/media/usergroup-blue-icon.81b6c60b99a30de65ce38cad776635cf.svg";
export { ForwardRef as ReactComponent };